export enum ContainerTypes {
  Action = "FSM_Action",
  Page = "Page",
  SearchStorage = "SearchStorage",
  RoutingStorage = "RoutingStorage",
  CommandStorage = "CommandStorage",
  DetailsStorage = "DetailsStorage",
  Startpage = "Startpage",
  Results = "Results",
  Routing = "Routing",
  Details = "Details",
  Config = "Config",
  Ekomi = "Ekomi"
}
